(() => {
  const dialog = document.querySelector("[data-tfrc-offer]");
  if (!dialog) return;

  const closeButton = dialog.querySelector("[data-tfrc-offer-close]");
  const copyButton = dialog.querySelector("[data-tfrc-offer-copy]");
  const offerCode = dialog.querySelector("[data-tfrc-offer-code]");
  const signup = dialog.querySelector("[data-tfrc-offer-signup]");
  const success = dialog.querySelector("[data-tfrc-offer-success]");
  const form = dialog.querySelector("form");
  const emailInput = form?.querySelector('input[type="email"]');
  const submitButton = form?.querySelector('button[type="submit"]');
  const asyncError = dialog.querySelector("[data-tfrc-offer-async-error]");
  const endpoint = dialog.dataset.tfrcNewsletterEndpoint;
  const subscribedKey = "tfrc-rc-weekly-subscribed";
  const dismissedKey = "tfrc-rc-weekly-dismissed-at";
  const dismissalWindow = 7 * 24 * 60 * 60 * 1000;
  let openedAutomatically = false;

  const isSuccessful = () => Boolean(success && !success.hidden);

  const stored = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  };

  const store = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // The offer still works when storage is unavailable.
    }
  };

  const openOffer = () => {
    if (typeof dialog.showModal === "function" && !dialog.open) {
      dialog.showModal();
    } else if (!dialog.open) {
      dialog.setAttribute("open", "");
    }
    document.documentElement.classList.add("tfrc-offer-open");
  };

  const closeOffer = () => {
    if (typeof dialog.close === "function" && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
    document.documentElement.classList.remove("tfrc-offer-open");
    if (window.location.hash === "#tfrc-welcome-offer") {
      history.replaceState(null, "", `${window.location.pathname}${window.location.search}`);
    }
    if (!isSuccessful()) store(dismissedKey, String(Date.now()));
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest('a[href="#tfrc-welcome-offer"], [data-tfrc-offer-open]');
    if (!trigger) return;
    event.preventDefault();
    history.replaceState(null, "", "#tfrc-welcome-offer");
    openOffer();
  });

  closeButton?.addEventListener("click", closeOffer);
  dialog.addEventListener("close", () => {
    document.documentElement.classList.remove("tfrc-offer-open");
    if (!isSuccessful()) store(dismissedKey, String(Date.now()));
  });
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) closeOffer();
  });

  copyButton?.addEventListener("click", async () => {
    const code = offerCode?.textContent?.trim();
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      copyButton.textContent = "Copied";
    } catch {
      window.getSelection()?.selectAllChildren(offerCode);
      copyButton.textContent = "Selected";
    }
  });

  form?.addEventListener("submit", async (event) => {
    if (!endpoint || isSuccessful() || form.dataset.tfrcSubmitted === "true") return;
    event.preventDefault();
    if (!form.reportValidity()) return;

    asyncError?.setAttribute("hidden", "");
    submitButton?.setAttribute("disabled", "");
    form.setAttribute("aria-busy", "true");
    const originalLabel = submitButton?.textContent;
    if (submitButton) submitButton.textContent = "Joining RC Weekly...";

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: new URLSearchParams({
          email: emailInput?.value || "",
          consent: "yes",
          website: form.elements.website?.value || "",
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload.ok) {
        throw new Error(payload.error || "We could not complete your signup. Please try again.");
      }
      store(subscribedKey, "true");
      form.dataset.tfrcSubmitted = "true";
      form.removeAttribute("aria-busy");
      signup?.setAttribute("hidden", "");
      success?.removeAttribute("hidden");
      success?.querySelector("h2")?.focus({ preventScroll: true });
    } catch (error) {
      if (asyncError) {
        asyncError.textContent = error instanceof Error
          ? error.message
          : "We could not complete your signup. Please try again.";
        asyncError.removeAttribute("hidden");
      }
      submitButton?.removeAttribute("disabled");
      form.removeAttribute("aria-busy");
      if (submitButton && originalLabel) submitButton.textContent = originalLabel;
    }
  });

  if (isSuccessful() || window.location.hash === "#tfrc-welcome-offer") {
    if (isSuccessful()) store(subscribedKey, "true");
    window.setTimeout(openOffer, 0);
    return;
  }

  const dismissedAt = Number(stored(dismissedKey) || 0);
  const autoEligible = stored(subscribedKey) !== "true"
    && (!dismissedAt || Date.now() - dismissedAt >= dismissalWindow);
  if (!autoEligible) return;

  const openAutomatically = () => {
    if (openedAutomatically || dialog.open || document.visibilityState !== "visible") return;
    openedAutomatically = true;
    openOffer();
  };
  const timer = window.setTimeout(openAutomatically, 5500);
  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.32) {
      window.clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      openAutomatically();
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
})();
